module.exports = __webpack_public_path__ + "static/media/analytics.b39b5988.png";